import { render } from "./ItemComment.vue?vue&type=template&id=3d23e62e&scoped=true&ts=true"
import script from "./ItemComment.vue?vue&type=script&lang=ts"
export * from "./ItemComment.vue?vue&type=script&lang=ts"

import "./ItemComment.vue?vue&type=style&index=0&id=3d23e62e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d23e62e"]])

export default __exports__